module.exports = __webpack_public_path__ + "static/media/bd.2f35de00.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/bd.svg
// module id = 60
// module chunks = 0